import { Button, HorizontalDivider, Image, Typography } from '@smartgift/frontend-toolkit';
import dayjs from 'dayjs';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { DetailGroup, DetailItem, OrderStatusBadge } from '@hero/components/molecules';
import { ShareLink, ShareQR } from '@hero/components/organisms/Share';
import { dateLabelFormatWithTime, RECOGNITIONS_TAB } from '@hero/constants';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetRecognition } from '@hero/services';

import * as S from './style';

function SendGiftWithoutContact() {
  const { t } = useTranslation();
  const { recognitionCode } = useParams();
  const navigate = useNavigate();
  const { data: recognition } = useGetRecognition({ recognitionCode });

  const secureSingleLink = recognition?.link?.shortened;

  return (
    <S.Wrapper>
      <S.LeftContent>
        <S.Content>
          <Image name="confirmationWithoutContact" height={214} />
          <S.TitleWrapper>
            <Typography variant="subtitle4Bold">{t('yourGiftLinkReadyToShare')}</Typography>
            <Typography>{t('yourGiftLinkReadyToShareDesc')}</Typography>
          </S.TitleWrapper>
        </S.Content>
        <ShareLink
          position="left-start"
          secureSingleLink={secureSingleLink}
          featureType="recognition"
          shareButtonVariant="contained"
        />
      </S.LeftContent>
      <S.RightContent>
        <S.RightBody>
          <S.StatusWrapper>
            <Typography variant="subtitle4SemiBold">{t('status')}</Typography>
            <OrderStatusBadge status={'live'} />
          </S.StatusWrapper>
          <S.QrWrapper>
            <ShareQR size={136} link={secureSingleLink} />
          </S.QrWrapper>
          <HorizontalDivider />
          <Typography variant="subtitle4SemiBold">{t('summary')}</Typography>
          <DetailGroup>
            <DetailItem title={`${t('giftCode')}:`} titleStyle={{ width: 150 }}>
              {recognitionCode}
            </DetailItem>
            <DetailItem title={`${t('name')}:`} titleStyle={{ width: 150 }}>
              {recognition?.name}
            </DetailItem>
            <DetailItem title={`${t('redemptionDeadline')}:`} titleStyle={{ width: 150 }}>
              {dayjs(recognition?.settings?.expiresAt).format(dateLabelFormatWithTime)}
            </DetailItem>
          </DetailGroup>
          <Typography variant="body2" color="fg" emphasis="weaker">
            <Trans
              i18nKey="orderConfirmationMessage"
              components={{
                a1: (
                  <S.SupportLink
                    href={`${ROUTE_PATHS.DASHBOARD}${ROUTE_PATHS.MY_RECOGNITION_DETAIL(recognitionCode)}#${
                      RECOGNITIONS_TAB.order
                    }`}
                  />
                ),
                a2: (
                  <S.SupportLink
                    href={`${ROUTE_PATHS.DASHBOARD}${ROUTE_PATHS.MY_RECOGNITION_DETAIL(recognitionCode)}#${
                      RECOGNITIONS_TAB.analytics
                    }`}
                  />
                )
              }}
            />
          </Typography>
          <S.ButtonGroup>
            <Button
              onClick={() => {
                navigate(
                  `${ROUTE_PATHS.MY_RECOGNITION_DETAIL(recognitionCode)}#${RECOGNITIONS_TAB.order}`
                );
              }}
              variant="outlined"
              block
            >
              {t('seeDetails')}
            </Button>
            <Button
              onClick={() => {
                navigate(
                  `${ROUTE_PATHS.MY_RECOGNITION_DETAIL(recognitionCode)}#${RECOGNITIONS_TAB.order}`
                );
              }}
              variant="outlined"
              block
            >
              {t('seeAnalytics')}
            </Button>
          </S.ButtonGroup>
        </S.RightBody>
        <S.OrderBodyFooterText>
          {
            <Trans
              i18nKey="orderConfirmedInfoText"
              components={{
                a: (
                  <S.SupportLink
                    href={`mailto:${t('mailTo')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                )
              }}
            />
          }
        </S.OrderBodyFooterText>
      </S.RightContent>
    </S.Wrapper>
  );
}

export { SendGiftWithoutContact };
